import { useSidebar } from '@feedback/ui';
// import { LayoutRoot } from '@feedback/ui';

import styled from 'styled-components';
import { useWindowSize } from 'use-window-size-hook';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  header: ReactNode;
  sidebar: ReactNode;
};

const Grid = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.open ? '240px' : '0')} 1fr;
  height: 100vh;
  width: 100%;
`;

const LayoutWrapper = ({ header, sidebar, children }: Props) => {
  const { isSidebarOpen } = useSidebar();
  const { width } = useWindowSize();

  const isMobile = width < 600;

  if (isMobile) {
    return (
      <>
        {header}
        {sidebar}
        {children}
      </>
    );
  }

  return (
    <Grid open={isSidebarOpen}>
      {sidebar}
      <div style={{ minWidth: 0 }}>
        {header}
        {children}
      </div>
    </Grid>
  );
};

export default LayoutWrapper;
